import React, {useState, useEffect, useRef} from "react";
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from "../components/FooterAdmin";
import { collection, addDoc, getDocs, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { database } from "../config/firebaseConfig";
import { XMarkIcon } from "@heroicons/react/24/outline";
import SearchBar from "../components/SearchBar";
import AlertBox from '../components/AlertBox';
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';

function CategoriesAdmin() {
    const SUCCESS = "success";
    const WARNING = "warning";

    const WAIT_TIME = 500; //Waits for 0.5s
    const notInitialRender = useRef(false);

    const getMaxProducts = (width) => {
      if (width>= 640) {
        return 10;
      }
  
      return 5;
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [categoriesPerPages, setCategoriesPerPages] = useState(getMaxProducts(window.innerWidth));

    const [categoryIdSelected, setCategoryIdSelected]= useState('');
    const [newData, setNewData] = useState(true);

    const [uploading, setUploading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [allKeywords, setAllKeywords] = useState(null);
    const [categoryName, setCategoryName] = useState("");
    const [keyWord, setKeyWord] = useState("");
    const [categories, setCategories] = useState(null);
    const [isOpenKeywords, setIsOpenKeywords] = useState(false);

    const lastCategoryIndex = currentPage * categoriesPerPages;
    const firstCategoryIndex = lastCategoryIndex - categoriesPerPages;

    const togglePopupDelete = (categoryId) =>{
      [].forEach.bind(document.getElementsByClassName(`popup_delete ${categoryId}`),function(itm){
        itm.style.display = "flex";
      })();
    }

    const closePopupDelete = (categoryId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${categoryId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
    Close the popup for the category
    */
    const closePopUpCategory = (categoryId) => {
      const popup = document.getElementById(categoryId);
      setCategoryIdSelected('');
      popup.classList.add('hidden');
      popup.classList.remove('flex');
    }

    /*
    Open the popup for the category
    */
    const togglePopUpCategory = (categoryId, categoryName) => {
      console.log(categoryId);
      const popup = document.getElementById(categoryId);
      popup.classList.remove('hidden');
      popup.classList.add('flex');
      setCategoryName(categoryName);
      setCategoryIdSelected(categoryId);
    }

    /*
    Close the popup for the keywords
    */
    const closePopUpKeyWords = (categoryId) => {
      [].forEach.bind(document.getElementsByClassName(`popup_keywords ${categoryId}`),function(itm){
        itm.style.display = "none";
      })();
      setIsOpenKeywords(false);
      setCategoryIdSelected('');
    }

    /*
    Open the popup for the keywords
    */
    const togglePopUpKeyWords = (categoryId) => {
      [].forEach.bind(document.getElementsByClassName(`popup_keywords ${categoryId}`),function(itm){
        itm.style.display = "flex";
      })();
      setIsOpenKeywords(true);
      setNewData(true);
      setCategoryIdSelected(categoryId);
    }

    /*
    gets all the keywords of a category
    */
    useEffect(() => {
      const interval = setInterval(() => { //Autorize re-render
          if (newData && isOpenKeywords) {
              const keywordsRef = collection(database, 'categorias', categoryIdSelected, 'palabras_clave');
              console.log(keywordsRef);
              const getKeywords = async() => {
                  const data = await getDocs(keywordsRef);
                  setAllKeywords(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
              }
              getKeywords();
          }
      }, WAIT_TIME);
      return () => clearInterval(interval);            
    }, [allKeywords, newData, categoryIdSelected, isOpenKeywords])

    /*
    Gets all the categories
    */
    useEffect(() => {
        if (notInitialRender.current && newData){
          AlertOnLoading(WAIT_TIME+100);
        }else {
            notInitialRender.current = true;
        } 
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const categoryCollectionRef = collection(database, "categorias");
                
                const getCategories = async() => {
                    const data = await getDocs(categoryCollectionRef);
                    setCategories(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                getCategories();
                setNewData(!newData);
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [categories, newData])

    /*
    Creates a category
    */
    async function createCategory() {
      if (categoryName === "") {
        AlertBox(WARNING, '¡Debe ingresar el nombre de la categoría!')
        return;

      } else if (keyWord === "") {
        AlertBox(WARNING, '¡Debe ingresar al menos una palabra clave!')
        return;
      } else {

        const addButton = document.querySelectorAll("#addRegister");
        addButton[0].setAttribute("disabled", true);

        setUploading(true);

        const categoryCollectionRef = collection(database, "categorias");
        const keywords = keyWord.split(" ");
        
        const categoryDoc = await addDoc(categoryCollectionRef, {
          nombre: categoryName});
        
        const keywordsCollectionRef = collection(database, 'categorias', categoryDoc.id, 'palabras_clave');
        keywords.map(async(keyword) => {
          await addDoc(keywordsCollectionRef, {
            nombre: keyword, 
          })
        })

        setCategoryName("");
        setKeyWord("");
        setNewData(true);

        addButton[0].removeAttribute("disabled");

        setUploading(false);

        AlertBox(SUCCESS, '¡Categoría creada correctamente!');
      }
    }

    /*
    Deletes a category
    */
    const deleteCategory = async (id) =>{
      const categoryDoc = doc(database, "categorias", id);
      await deleteDoc(categoryDoc);
      setNewData(true);
      AlertBox(SUCCESS, '¡Categoría eliminada correctamente!');
      closePopupDelete(id);
    }

    /*
    Deletes a keyword
    */
    const deleteKeyWord = async (id) =>{
      const keyWordDoc = doc(database, "categorias", categoryIdSelected, "palabras_clave", id);
      await deleteDoc(keyWordDoc);
      setNewData(true);
      AlertBox(SUCCESS, '¡Palabra eliminada correctamente!');
    }

    const deleteNumbers = (selectedId) => {
      return selectedId.replace(/\d+/g, '');
    }

    /*
    Updates a category
    */
    async function updateCategory() {
      const updateButton = document.querySelectorAll(`button.${deleteNumbers(categoryIdSelected)}`);
      updateButton[0].setAttribute("disabled", true);

      setUpdating(true);
      
      const updateCategoryRef = doc(database, 'categorias', categoryIdSelected);
      await updateDoc(updateCategoryRef, {nombre:categoryName});
      
      setCategoryName("");
      setNewData(true);

      updateButton[0].removeAttribute("disabled");

      setUpdating(false);
      AlertBox(SUCCESS, '¡Prueba actualizada correctamente!');
      closePopUpCategory(categoryIdSelected);
      return;
    }

    const resizeProducts = () => {
      setCategoriesPerPages(getMaxProducts(window.innerWidth));
      return;
    }

    window.addEventListener("resize", resizeProducts)
    return (
      <div>
          <div>
            <Toaster
            toastOptions={{
                duration:3000,
            }}/>
          </div>
        
          <NavbarReturn />

          <div className="w-full h-navbar-mobile sm:h-navbar"/>
            <div className='lg:px-8 px-4 py-6 flex flex-col w-full h-auto bg-white min-h-screen'>
              <h2 className='lg:text-xl'>Crear una Categoría</h2>
              <span className='lg:w-80 w-48 border border-primary-100'></span>

              <div className="h-52 space-y-4 px-4 py-6 w-60 sm:flex sm:flex-col sm:w-96 sm:justify-start lg:w-input-web">
                <input onChange={(ev) => {setCategoryName(ev.target.value)}} value={categoryName} type={"text"} placeholder="Nombre"
                className='text-sm sm:text-base w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                <input onChange={(ev) => {setKeyWord(ev.target.value)}} type={"text"} value={keyWord} placeholder="Palabras Clave"
                className='text-sm sm:text-base w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                <button onClick={createCategory} id="addRegister"
                  className='w-full h-8 text-sm sm:text-base sm:w-full sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200 disabled:bg-primary-200'>
                  {!uploading? 
                  "Agregar"
                  : 
                  <div className="w-full flex justify-center items-center"> 
                      <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                      <path clipRule='evenodd'
                          d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                          fill='currentColor' fillRule='evenodd' />
                      </svg> 
                      Agregando
                  </div>}
                </button>
              </div>

              <h2 className='lg:text-xl mt-10'>Todas las Categorías</h2>
              <span className=' lg:w-80 w-48 border border-primary-100'></span>

              <div className={`${categories? "block mt-8":"hidden"}`}>
                <SearchBar options={["Antiguos", "Recientes"]} allDocs={''}/>
              </div>

            
            <div className="sm:flex sm:flex-col sm:px-10 sm:w-full sm:justify-center sm:items-center mt-5">
              <div className={`sm:flex sm:flex-col sm:w-full sm:space-y-1 sm:justify-center ${categories? "sm:border sm:border-primary-100":"border-none"}} p-1 sm:max-w-table-web`}>
                  <div className={`${categories? "hidden w-full  sm:flex flex-row space-x-1":"hidden"}`}>
                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Categoría</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Nombre</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Acción</h3>
                    </div>
                  </div>
              {categories? categories.slice(firstCategoryIndex, lastCategoryIndex).map((category, index)=> (
                <div key={index}>
                  <div className="hidden w-full sm:flex flex-row space-x-1">
                    <div className="flex justify-center items-center w-full h-8 bg-background">
                      <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{index}</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-background">
                      <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{category.nombre}</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-background space-x-2">
                      <div className='w-1/3 h-9 flex justify-center items-center'>
                        <button onClick={() => {togglePopUpKeyWords(category.id);}} 
                        className='w-full h-7 text-sm bg-success text-white rounded-md font-bold lg:text-xl form1:text-xl hover:bg-green-500'>Palabras</button>
                      </div>
                      <div className='w-1/3 h-9 flex justify-center items-center'>
                        <button onClick={() => {togglePopUpCategory(category.id, category.nombre)}} 
                        className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold lg:text-xl form1:text-xl hover:bg-primary-200'>Editar</button>
                      </div>
                      <div className='w-1/3 h-9 flex justify-center items-center'>
                        <button onClick={() => {togglePopupDelete(category.id);}} 
                        className='w-full h-7 text-sm bg-danger text-white rounded-md font-bold lg:text-xl form1:text-xl hover:bg-red-400'>Eliminar</button>
                      </div>
                    </div>
                  </div>

                  <div className="w-full mb-4 flex justify-center sm:hidden sm:w-auto sm:flex-col sm:border sm:border-primary-100 sm:max-w-table-web sm:justify-center form1:mx-80 lg:justify-center lg:mx-56 lg:max-w-table-web">
                    <div className="flex flex-col space-y-1 border border-primary-100 p-1 justify-center w-4/5 h-auto sm:flex-row sm:space-y-0 sm:space-x-1 sm:w-full max-w-table-web sm:border-none">
                      <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                        <h3 className="text-sm text-primary-100">Categoría</h3>
                      </div>

                      <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                        <h3 className="text-sm text-navFont-100">{index}</h3>
                      </div>

                      <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                        <h3 className="text-sm text-primary-100">Nombre</h3>
                      </div>

                      <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                        <h3 className="text-sm text-navFont-100">{category.nombre}</h3>
                      </div>

                      <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                        <h3 className="text-sm text-primary-100">Acción</h3>
                      </div>

                      <div className='w-full h-8 flex justify-center items-center bg-background sm:hidden space-x-2'>
                        <div className='w-1/3 h-9 flex justify-center items-center'>
                          <button onClick={() => {togglePopUpKeyWords(category.id);}} 
                          className='w-full h-7 text-sm bg-success text-white rounded-md font-bold hover:bg-green-500'>Palabras</button>
                        </div>
                        <div className='w-1/3 h-9 flex justify-center items-center'>
                          <button onClick={() => {togglePopUpCategory(category.id)}} 
                          className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar</button>
                        </div>
                        <div className='w-1/3 h-9 flex justify-center items-center'>
                          <button onClick={() => {togglePopupDelete(category.id);}} 
                          className='w-full h-7 text-sm bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-40 items-center justify-center ${category.id} popup_keywords`}>
                      <div className='relative w-3/4 flex flex-col justify-center items-center h-auto space-x-1 bg-white rounded overflow-y-auto py-8 max-h-popup-mobile max-w-3xl'>
                          <button onClick={() => {closePopUpKeyWords(category.id);}} className='absolute top-1 right-1 hover:text-primary-100'><XMarkIcon className='w-7 h-7'/></button>

                          <div className="flex flex-col justify-center items-center my-5">
                            <h2 className='flex flex-row lg:text-xl'>Palabras Clave</h2>
                            <span className='lg:w-80 w-48 border border-primary-100'></span>
                          </div>
                          
                          <div className="p-1 flex w-3/4 flex-col justify-center items-center border border-primary-100 h-auto max-w-table-web">
                              <div className="w-full flex flex-row space-x-1">
                                  <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                      <h3 className={`text-sm text-primary-100`}>Palabras Clave</h3>
                                  </div>
                                  <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                      <h3 className={`text-sm text-primary-100`}>Acción</h3>
                                  </div>
                              </div>

                              {allKeywords?.map((keyword) => (
                                  <div key={keyword.id} className="flex flex-row justify-center items-center w-full h-10 sm:flex-col sm:w-full sm:max-w-table-web sm:justify-center form1:mx-80 lg:justify-center lg:mx-56 lg:max-w-table-web">
                                      <div className="flex flex-row justify-between space-x-1 w-full h-8 sm:flex-row sm:space-y-0 sm:space-x-1 sm:w-full max-w-table-web sm:border-none">
                                          <div className="flex justify-center items-center w-full h-9 bg-background">
                                              <h3 className="text-sm text-navFont-100">{keyword.nombre}</h3>
                                          </div>

                                          
                                          <div className='w-full h-9 flex justify-center items-center bg-background'>
                                              <button onClick={() => {deleteKeyWord(keyword.id)}} 
                                              className='w-3/4 h-8 text-sm bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                                          </div>
                                      </div>
                                  </div>
                              ))}
                              
                          </div>
                      </div>
                  </div>

                  <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-40 items-center justify-center`} id={category.id}> 
                    <div className='relative sm:max-w-3xl w-full flex flex-col justify-center py-3 items-center mx-10 sm:mx-5 sm:px-3 h-auto bg-white rounded overflow-y-auto max-h-popup-mobile'>
                        <div className='w-full flex flex-col items-center justify-center mt-3'>
                            <h2 className='flex flex-row md:text-xl'>Editar una Categoría </h2>
                            <span className='md:w-80 w-48 h-px border border-primary-100'></span>
                        </div>
                        <button onClick={() => {closePopUpCategory(category.id)}} className='absolute top-1 right-1'><XMarkIcon className='w-7 h-7'/></button>
                        <div className='sm:static sm:space-x-3 sm:items-start sm:flex-row relative w-full flex flex-col justify-center py-3 items-center mx-0 h-auto bg-white rounded overflow-y-auto'>
                            <div className='w-full flex flex-col items-center justify-center'>
                                

                                <div className='w-52 mt-3 sm:w-5/6'>
                                    <input type={"text"} placeholder="Nombre" onChange={(ev) => {setCategoryName(ev.target.value)}} value={categoryName}
                                    className='md:text-base text-sm w-full h-8 py-2 px-3 text-input-font bg-primary-300
                                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                                </div>

                            </div>
                        </div>
                        <div className='w-52 mt-3 flex flex-row'>
                            <button onClick={updateCategory} 
                              className={`w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold hover:bg-primary-200 disabled:bg-primary-200 ${deleteNumbers(category.id)}`}>
                              {!updating? 
                              "Guardar"
                              : 
                              <div className="w-full flex justify-center items-center"> 
                                  <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                  <path clipRule='evenodd'
                                      d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                      fill='currentColor' fillRule='evenodd' />
                                  </svg> 
                                  Guardando
                              </div>}
                            </button>
                        </div>
                    </div>
                </div>

                <div className={`hidden relative z-40 popup_delete ${category.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                    <div className="fixed inset-0 bg-popup"></div>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                    <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                    </svg>
                                </div>
                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                    <div className="mt-2">
                                    <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button onClick={() => {deleteCategory(category.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                <button onClick={() => {closePopupDelete(category.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              ))
              :
              <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                  <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                      <path clipRule='evenodd'
                          d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                          fill='currentColor' fillRule='evenodd' />
                  </svg>
                  <div>
                      Cargando...
                  </div>
              </div>
              }
              </div>
              <div className={`${categories?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                <span className={`text-sm text-gray-700`}>
                    Mostrando <span className="font-semibold text-gray-900">{lastCategoryIndex >= categories?.length? categories?.length:lastCategoryIndex}</span> de <span className="font-semibold text-gray-900">{categories?.length}</span> resultados
                </span>
                <div className="inline-flex mt-2 xs:mt-0">
                    <button
                        onClick={() => {setCurrentPage(currentPage - 1)}} 
                        className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                        Anterior
                    </button>
                    <button 
                        onClick={() => {setCurrentPage(currentPage + 1)}}
                        
                        className={`${lastCategoryIndex >= categories?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                        Siguiente
                    </button>
                </div>
              </div>
            </div>
          </div>
          <FooterAdmin />
      </div>
    )
  }

export default CategoriesAdmin;